module.exports = __webpack_public_path__ + "static/img/Ajustados sin fondo_terminar prueba.d279c41e.svg";